export default __webpack_public_path__ + "static/media/logo_cte_natal.6eab9a20.png";